import type { State } from '@jira/issue__redux-state-types/src/ReduxState.types.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import { deleteWebLinkRequest } from '@atlassian/jira-issue-view-store/src/actions/web-links-actions.tsx';
import type { DispatchProps, Props } from './types.tsx';
import { LoomVideoCard } from './view.tsx';

export default connect<{}, DispatchProps, Props, State>(
	null,
	(dispatch, { link: { id: linkId } }) => ({
		onDeleteWebLinkRetry: () => {
			dispatch(deleteWebLinkRequest(linkId));
		},
	}),
)(LoomVideoCard);
